"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPreferenceDurabiliteTrads = void 0;
exports.ESubPreferenceDurabiliteTrads = {
    prise_en_compte_principales_incidences_negatives: "Prise en compte des principales incidences négatives sur les facteurs de durabilité",
    investissements_durables: "Investissements durables (Art. 2 Nr. 17 du règlement (UE) 2019/2088 - SFDR)",
    investissements_durables_sur_plan_environnemental: "Investissements durables sur le plan environnemental (Art. 2 Nr. 1 du règlement (UE) 2020/852– Règlement Taxonomie)",
};
